import React, { FC, useState, ChangeEvent } from 'react';
import {
  Grid,
  Paper,
  Typography,
  Card,
  CardContent,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tabs,
  Tab,
} from '@material-ui/core';
import AssessmentIcon from '@material-ui/icons/Assessment';
import PeopleIcon from '@material-ui/icons/People';
import AppsIcon from '@material-ui/icons/Apps';
import { DateRange } from 'materialui-daterange-picker';
import { DateRangePicker } from 'components/DateRangePicker';
import { todayEnd, todayStart } from 'components/DateRangePicker/DefaultRanges';
import { useStyles } from './styles';
import { useStore } from 'hooks/useRootStore';
import { useQuery } from 'react-query';
import { useAppPreloader } from 'hooks/useAppPreloader';
import TabPanel from 'components/TabPanel';
// interface ReportData {
//     totalAuthentications: number;
//     uniqueUsers: number;
//     connectedApps: number;

// }

const toReportDateParam = (date: Date) => {
  const year = date.getFullYear();
  const month = `${date.getMonth() + 1}`.padStart(2, '0');
  const day = `${date.getDate()}`.padStart(2, '0');

  return `${year}-${month}-${day}`;
};

const OIDC: FC = () => {
  const classes = useStyles();
  const period = 'day';
  const [dateRange, setDateRange] = useState<DateRange>({
    startDate: todayStart,
    endDate: todayEnd,
  });
  // const [reportData, setReportData] = useState<ReportData | null>(null);
  const [activeTab, setActiveTab] = useState('one');
  const startDate = toReportDateParam(dateRange.startDate as Date);
  const endDate = toReportDateParam(dateRange.endDate as Date);

  function a11yProps(index: string) {
    return {
      id: `wrapped-tab-${index}`,
      'aria-controls': `wrapped-tabpanel-${index}`,
    };
  }

  const handleTabChange = (event: ChangeEvent<unknown>, newValue: string) => {
    setActiveTab(newValue);
  };
  const {
    logsTableStore: { getOidcReports, showAllDateRange },
    notificationStore: { openNotification },
  } = useStore();

  const getOidcReportsReq = useQuery(
    ['getOidcReportsReq', period, startDate, endDate],
    () => getOidcReports(period, startDate, endDate),
    {
      onError: (e: any) => {
        openNotification('error', `Can't Get OIDC Reports`);
      },
    }
  );

  const currentStats = {
    totalAuthentications:
      getOidcReportsReq.data?.data?.authentications_by_period?.data?.reduce(
        (sum: number, item: any) => sum + item.authentication_count,
        0
      ) || 0,
    uniqueUsers:
      getOidcReportsReq.data?.data?.unique_users_by_period?.data?.reduce(
        (sum: number, item: any) => sum + item.unique_user_count,
        0
      ) || 0,
    connectedApps: getOidcReportsReq.data?.data?.connected_apps?.data?.length || 0,
    avgAuthsPerDay:
      getOidcReportsReq.data?.data?.authentications_by_period?.data?.length > 0
        ? Math.round(
            (getOidcReportsReq.data?.data?.authentications_by_period?.data?.reduce(
              (sum: number, item: any) => sum + item.authentication_count,
              0
            ) || 0) / (getOidcReportsReq.data?.data?.authentications_by_period?.data?.length || 1)
          )
        : 0,
  };

  useAppPreloader(getOidcReportsReq.isFetching);
  return (
    <>
      <Grid container justify='space-between' alignItems='center' className={classes.box}>
        <div className={classes.flex}>
          <DateRangePicker
            initialRange={dateRange}
            customRanges={[
              { label: 'Show All', startDate: showAllDateRange.startDate, endDate: showAllDateRange.endDate },
            ]}
            onChange={setDateRange}
          />
        </div>
      </Grid>
      <Tabs
        value={activeTab}
        onChange={handleTabChange}
        className={classes.tabs}
        TabIndicatorProps={{ style: { color: 'transparent', background: 'transparent' } }}
        variant='standard'
      >
        <Tab value='one' label='Authenticate' {...a11yProps('one')} className={classes.label} />
        <Tab value='two' label='Unique Users' {...a11yProps('two')} className={classes.label} />
        <Tab value='three' label='Connected Apps' {...a11yProps('three')} className={classes.label} />
      </Tabs>
      <div className={classes.tabBox}>
        <TabPanel value={activeTab} index='one'>
          <Grid container spacing={3}>
            {getOidcReportsReq.data?.data?.authentications_by_period?.data?.length > 0 ? (
              getOidcReportsReq.data?.data?.authentications_by_period?.data?.map((item: any, index: number) => (
                <Grid item xs={12} sm={6} md={4} key={index}>
                  <Card className={classes.statsCard}>
                    <CardContent>
                      <AssessmentIcon className={classes.statsIcon} style={{ color: '#1976d2' }} />
                      <Typography className={classes.statsValue}>
                        {item.authentication_count.toLocaleString()}
                      </Typography>
                      <Typography className={classes.statsLabel}>Authentications - {item.period}</Typography>
                      <Typography variant='body2' style={{ marginTop: 8, color: '#666' }}>
                        Period: {period} | {item.period}
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>
              ))
            ) : (
              <Grid item xs={12}>
                <Card className={classes.statsCard}>
                  <CardContent>
                    <Typography align='center'>No authentication data available</Typography>
                  </CardContent>
                </Card>
              </Grid>
            )}
          </Grid>
        </TabPanel>

        <TabPanel value={activeTab} index='two'>
          <Grid container spacing={3}>
            {getOidcReportsReq.data?.data?.unique_users_by_period?.data?.length > 0 ? (
              getOidcReportsReq.data?.data?.unique_users_by_period?.data?.map((item: any, index: number) => (
                <Grid item xs={12} sm={6} md={4} key={index}>
                  <Card className={classes.statsCard}>
                    <CardContent>
                      <PeopleIcon className={classes.statsIcon} style={{ color: '#4caf50' }} />
                      <Typography className={classes.statsValue}>{item.unique_user_count.toLocaleString()}</Typography>
                      <Typography className={classes.statsLabel}>Unique Users - {item.period}</Typography>
                      <Typography variant='body2' style={{ marginTop: 8, color: '#666' }}>
                        Period: {period} | {item.period}
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>
              ))
            ) : (
              <Grid item xs={12}>
                <Card className={classes.statsCard}>
                  <CardContent>
                    <Typography align='center'>No unique users data available</Typography>
                  </CardContent>
                </Card>
              </Grid>
            )}
          </Grid>
        </TabPanel>

        <TabPanel value={activeTab} index='three'>
          <Paper className={classes.tableContainer}>
            {/* <Typography variant="h6" style={{ padding: 16, borderBottom: '1px solid #e0e0e0' }}>
                            Connected Apps
                        </Typography> */}
            <TableContainer>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>
                      <strong> Connected Apps</strong>
                    </TableCell>
                    <TableCell align='center'>
                      <strong>Number of Unique Users</strong>
                    </TableCell>
                    <TableCell align='center'>
                      <strong>Number of Logins</strong>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {getOidcReportsReq.data?.data?.connected_apps?.data?.length > 0 ? (
                    getOidcReportsReq.data?.data?.connected_apps?.data?.map((app: any) => (
                      <TableRow key={app.app_name}>
                        <TableCell component='th' scope='row'>
                          {app.app_name}
                        </TableCell>
                        <TableCell align='center'>{app.unique_user_count}</TableCell>
                        <TableCell align='center'>{app.login_count}</TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell colSpan={3} align='center'>
                        No connected apps data available
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>
        </TabPanel>
      </div>
      {false && (
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6} md={3}>
            <Card className={classes.statsCard}>
              <CardContent>
                <AssessmentIcon className={classes.statsIcon} style={{ color: '#1976d2' }} />
                <Typography className={classes.statsValue}>
                  {currentStats.totalAuthentications.toLocaleString()}
                </Typography>
                <Typography className={classes.statsLabel}>Total Authentications</Typography>
              </CardContent>
            </Card>
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <Card className={classes.statsCard}>
              <CardContent>
                <PeopleIcon className={classes.statsIcon} style={{ color: '#4caf50' }} />
                <Typography className={classes.statsValue}>{currentStats.uniqueUsers.toLocaleString()}</Typography>
                <Typography className={classes.statsLabel}>Unique Users</Typography>
              </CardContent>
            </Card>
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <Card className={classes.statsCard}>
              <CardContent>
                <AppsIcon className={classes.statsIcon} style={{ color: '#ff9800' }} />
                <Typography className={classes.statsValue}>{currentStats.connectedApps}</Typography>
                <Typography className={classes.statsLabel}>Connected Apps</Typography>
              </CardContent>
            </Card>
          </Grid>

          {/* <Grid item xs={12} sm={6} md={3}>
                    <Card className={classes.statsCard}>
                        <CardContent>
                            <TrendingUpIcon className={classes.statsIcon} style={{ color: '#9c27b0' }} />
                            <Typography className={classes.statsValue}>
                                {currentStats.avgAuthsPerDay}
                            </Typography>
                            <Typography className={classes.statsLabel}>
                                Avg. Auths/Day
                            </Typography>
                        </CardContent>
                    </Card>
                </Grid> */}
        </Grid>
      )}
      {false && (
        <Paper className={classes.tableContainer} style={{ marginTop: 24 }}>
          {/* <Typography variant="h6" style={{ padding: 16, borderBottom: '1px solid #e0e0e0' }}>
                    Connected Apps
                </Typography> */}
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>
                    <strong>Connected Apps</strong>
                  </TableCell>
                  <TableCell align='center'>
                    <strong>Number of Unique Users</strong>
                  </TableCell>
                  <TableCell align='center'>
                    <strong>Number of Logins</strong>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {getOidcReportsReq.data?.data?.connected_apps?.data?.map((app: any) => (
                  <TableRow key={app.app_name}>
                    <TableCell component='th' scope='row'>
                      {app.app_name}
                    </TableCell>
                    <TableCell align='center'>{app.unique_user_count}</TableCell>
                    <TableCell align='center'>{app.login_count}</TableCell>
                  </TableRow>
                )) || (
                  <TableRow>
                    <TableCell colSpan={3} align='center'>
                      No connected apps data available
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>
      )}
    </>
  );
};

export default OIDC;
